@if (buttons.length) {
  <span class="technology-actions">
    @for (button of buttons; track button.id) {
      <a
        class="technology-button"
        [href]="button.url"
        target="_blank"
        rel="noopener noreferrer"
        [matTooltip]="button.tooltip | translate"
        matTooltipClass="site-technology-tooltip"
        matTooltipPosition="below"
        [attr.aria-label]="button.tooltip | translate"
      >
        @if (button.iconType === 'font') {
          <i class="technology-font-icon" [ngClass]="button.icon" aria-hidden="true"></i>
        } @else {
          <img
            width="24"
            height="24"
            [src]="button.icon | imageSrc | async"
            [alt]="button.tooltip | translate"
          />
        }
      </a>
    }
  </span>
}
